const baseURL = import.meta.env.VITE_API_BASE_URL.replace(/\/api$/, '')
const apiURL = import.meta.env.VITE_API_BASE_URL

export default {
  apiURL,
  baseURL,
}
